"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var _component = require("../../component");

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var getInsertedText = function getInsertedText(startPosition, endPosition, stringInserted, stringToInsertTo) {
  return stringToInsertTo.substring(0, startPosition) + stringInserted + stringToInsertTo.substring(endPosition, stringToInsertTo.length);
};

var TextAreaSelect = function TextAreaSelect(_ref) {
  var id = _ref.id,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      placeholder = _ref.placeholder,
      isOpen = _ref.isOpen,
      wrapperClassName = _ref.wrapperClassName,
      _ref$positionHorizont = _ref.positionHorizontal,
      positionHorizontal = _ref$positionHorizont === void 0 ? 'bottom' : _ref$positionHorizont,
      _ref$positionVertical = _ref.positionVertical,
      positionVertical = _ref$positionVertical === void 0 ? 'left' : _ref$positionVertical,
      _ref$horizontalSize = _ref.horizontalSize,
      horizontalSize = _ref$horizontalSize === void 0 ? 'regular' : _ref$horizontalSize,
      onOutsideClick = _ref.onOutsideClick,
      items = _ref.items,
      insertLabel = _ref.insertLabel,
      onTextChanged = _ref.onTextChanged,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["id", "onOpen", "onClose", "disabled", "readOnly", "placeholder", "isOpen", "wrapperClassName", "positionHorizontal", "positionVertical", "horizontalSize", "onOutsideClick", "items", "insertLabel", "onTextChanged"]);
  var classes = useStyles();

  var _onClickOutside = function _onClickOutside(e) {
    var _Array$from, _e$target;

    if (!((_Array$from = Array.from(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.classList)) === null || _Array$from === void 0 ? void 0 : _Array$from.includes("".concat(id, "-TextAreaSelect")))) {
      onOutsideClick === null || onOutsideClick === void 0 ? void 0 : onOutsideClick(e);
      onClose(e);
    }
  };

  var textAreaRef = (0, React.useRef)(null);

  var insertText = function insertText(value) {
    var element = textAreaRef.current;

    if (element) {
      var startPosition = element.selectionStart;
      var endPosition = element.selectionEnd;
      element.value = getInsertedText(startPosition, endPosition, value, element.value);
      element.selectionStart = startPosition + value.length;
      element.selectionEnd = startPosition + value.length;
    }
  };

  var onClickInsert = function onClickInsert(value) {
    return function () {
      insertText(value);
      var element = textAreaRef.current;
      element && (onTextChanged === null || onTextChanged === void 0 ? void 0 : onTextChanged(element.value));
      element === null || element === void 0 ? void 0 : element.focus();
    };
  };

  var _onTextChanged = function _onTextChanged(event) {
    onTextChanged === null || onTextChanged === void 0 ? void 0 : onTextChanged(event.target.value);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName,
    "data-test-id": "text-area-select",
    id: "".concat(id, "-wrapper"),
    onFocus: !disabled && !readOnly ? onOpen : undefined
  }, /*#__PURE__*/React.createElement(_component.Trigger, {
    face: /*#__PURE__*/React.createElement(_component.TextArea, (0, _extends2["default"])({
      className: (0, _classnames["default"])("".concat(id, "-TextAreaSelect"), props.className),
      id: id,
      "data-clickable": "".concat(id, "-TextAreaSelect"),
      placeholder: placeholder || '',
      ref: textAreaRef,
      onChange: _onTextChanged,
      disabled: disabled,
      readOnly: readOnly
    }, props)),
    open: isOpen,
    positionHorizontal: positionHorizontal,
    positionVertical: positionVertical,
    constraints: [{
      to: 'window',
      attachment: 'together'
    }],
    classes: {
      element: classes.tetherElement
    },
    onOutsideClick: _onClickOutside
  }, /*#__PURE__*/React.createElement(_component.Menu, {
    "data-test-id": "text-area-select-menu",
    id: "".concat(id, "-TextAreaSelectMenu"),
    "data-clickable": "".concat(id, "-TextAreaSelect"),
    className: (0, _classnames["default"])(classes.Menu, "horizontal-".concat(horizontalSize))
  }, items.map(function (item) {
    return /*#__PURE__*/React.createElement(_component.Menu.Item, {
      key: item.value,
      "data-value": item.value,
      onClick: onClickInsert(item.value),
      className: classes.MenuItem
    }, /*#__PURE__*/React.createElement("p", null, item.label), /*#__PURE__*/React.createElement(_component.Label, {
      className: "insert-label"
    }, insertLabel));
  }))));
};

exports["default"] = TextAreaSelect;
//# sourceMappingURL=index.js.map